import { CalendarEvent } from 'api/orders/schemas';
import { CalendarContent } from './CalendarContent';

const Calendar = ({
  value,
  onChange,
  trackingDate,
  onTrackingDateChange,
  direction,
  events,
}: {
  value: Date;
  onChange: (date: Date) => void;
  trackingDate: Date;
  onTrackingDateChange: (date: Date) => void;
  direction: 'left' | 'right';
  events: CalendarEvent[];
}) => {
  return (
    <div className="min-w-[321px]">
      <CalendarContent
        value={value}
        onChange={(date) => {
          if (date) onChange(date);
        }}
        events={events}
        trackingDate={trackingDate}
        onTrackingDateChange={onTrackingDateChange}
        direction={direction}
      />
    </div>
  );
};
export default Calendar;
